import dispatcher from "../dispatcher";
import { notificationConstant } from "../constants/constants";
import rq from "../components/utility/rq.js";

export function getAllNotification() {
    rq.getJsonData("/api/v1/getnotification").then((data) => {
        dispatcher.dispatch({ type: notificationConstant.FETCHED_ALL_NOTIFICATION, data });
    }).catch((data) => {
        dispatcher.dispatch({ type: notificationConstant, msg: "Fetching notification failed" });
    });

}


// WEBPACK FOOTER //
// ./src/jsx/actions/notification-action.jsx